// extracted by mini-css-extract-plugin
export default {"main":"Faq_main__9SbSx","wrap":"Faq_wrap__BEdqG","logoBg":"Faq_logoBg__Jlv81","container":"Faq_container__QYLBR","title":"Faq_title__YAVO8","textBox":"Faq_textBox__5-tMC"};